import { Box, DashboardModuleListItem, Tag } from '@domain-group/suit-theme'

import type { TaskListTemplateItemModel } from '@models/types'

import useTaskListTemplateItem from '@hooks/useTaskListTemplateItem'

interface TaskListTemplateItemProps {
  taskListTemplateItem: TaskListTemplateItemModel,
}

const TaskListTemplateItem = (props: TaskListTemplateItemProps) => {
  const { taskListTemplateItem } = props

  const taskListTemplateItemPayload = useTaskListTemplateItem(taskListTemplateItem)
  const {
    callbacks: { createOrEditTaskListTemplateItem },
    taskListTemplateItem: { assigned_points, description, title },
  } = taskListTemplateItemPayload

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditTaskListTemplateItem()}
      secondaryText={description}
      title={title}
    >
      <Box marginLeft="auto" width="auto">
        {!!assigned_points && (
          <Tag
            boxProps={{
              color: 'bodyFontColor',
              display: 'inline-flex',
              fontSize: 'xxsmall',
              fontStyle: 'normal',
              paddingX: 'medium',
              variant: 'whiteGrey',
            }}
            width="auto"
          >
            {assigned_points} Points
          </Tag>
        )}
      </Box>
    </DashboardModuleListItem>
  )
}

export default TaskListTemplateItem
